module.exports = __webpack_public_path__ + "img/Viktor Tron.eb2ef075.jpg";